import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FourierSineCosine = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Fourier Sine and Cosine Transforms"
    videos={[
      "https://www.youtube.com/embed/5NlOyd87Y4U",
      "https://www.youtube.com/embed/Kgl_ir7TLOk",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default FourierSineCosine;
